import React from 'react'
import { Row, Col } from 'antd'
import { service1, service2 } from '../../assets'
function Services() {
    return (
        <div className='services_container'>
            <h2>INDUSTRIES WE ALSO COVER</h2>
            <Row className='services' justify='center' style={{ gap: "25px" }} >
                <Col lg={11} md={23} sm={23} >
                    <div
                        className="service"
                        style={{
                            background: `url(${service1})`,
                            backgroundSize: "contain",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat"
                        }}
                    >
                        <h3 className="overlay">NFT Game Development</h3>
                    </div>
                </Col>
                <Col lg={11} md={23} sm={23}>
                    <div
                        className="service"
                        style={{
                            background: `url(${service2})`,
                            backgroundSize: "contain",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat"
                        }}
                    >
                        <h3 className="overlay">AR/VR Game Development</h3>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default Services